import React, { Fragment } from 'react'
import { ThemeProvider } from '@mafc/trolly'
import {
  Footer,
  Types,
  setAppLanguageAndCountry,
  HeaderNewJourney,
  HelpersUtil
} from '@mafc/common'
import { useBreakpoints } from '@mafc/hooks'
import { LayoutChildrenWrapper } from './Layout.styles'
import { useSelector } from 'react-redux'
import { isServer } from '../../utils'
import useViewPortEffect from './hooks/useViewPortEffect.hooks'
import { BackToTop } from '../../components/BackToTop'

export interface IProps {
  children: React.ReactElement | React.ReactElement[] | any
  language: string
  baseTheme?: any
  withLayout?: boolean
}

const Layout: React.FunctionComponent<IProps> = ({
  children,
  language,
  baseTheme = {},
  withLayout = true
}) => {
  const device = useBreakpoints()
  useViewPortEffect(device)
  const appConfig = useSelector(
    (state: { appConfig: Types.IAppConfig }) => state.appConfig
  )
  const { storeId: reduxStoreId, features } = appConfig
  const { languageChange } = features || {}

  const isBrowser = () => typeof window !== 'undefined'
  const pathName = (isBrowser() && window.location.pathname) || ''

  const onLanguageChange = (lan: string) => {
    const asPath = pathName + window.location.search
    const pathResources = asPath.split('/')
    const [, storeId, queryLang, ...rest] = pathResources
    let baseUrl = asPath
    const { appboy } = window as any

    setAppLanguageAndCountry(
      { language: lan, storeId: appConfig.storeId },
      appboy
    )
    if (
      storeId.indexOf('maf') > -1 &&
      ['ar', 'en', 'ka'].indexOf(queryLang) > -1
    ) {
      baseUrl = `${storeId}/${lan}/${rest.join('/')}`
      const finalPathName =
        storeId && queryLang ? baseUrl : `${reduxStoreId}/${lan}${baseUrl}`

      window.location.href = `https://${window.location.hostname}/${finalPathName}`
    } else {
      window.location.reload()
    }
  }

  const { addressNewJourney } = appConfig
  const showOldAddressJourney = HelpersUtil.shouldAlwaysShowOlderAddressJourney()

  return (
    <ThemeProvider
      addressNewJourney={addressNewJourney && !showOldAddressJourney}
      extraTheme={baseTheme}
      language={language}
    >
      {withLayout && (
        <HeaderNewJourney
          isLanguageChangeEnabled={languageChange}
          onLanguageChange={onLanguageChange}
        />
      )}
      {withLayout ? (
        <LayoutChildrenWrapper mt={[20, null, null, null, 20]} mb={40}>
          {children}
        </LayoutChildrenWrapper>
      ) : (
        <Fragment>{children}</Fragment>
      )}
      {withLayout && !isServer() && (
        <Fragment>
          <BackToTop />
          <Footer />
        </Fragment>
      )}
    </ThemeProvider>
  )
}

export default React.memo(
  Layout,
  (
    { language: prevLanguage, withLayout: prevWithLayout },
    { language: nextLanguage, withLayout: nextWithLayout }
  ) => {
    return prevLanguage !== nextLanguage || prevWithLayout !== nextWithLayout
  }
)
